import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionTitleProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
  action?: React.ReactNode;
  sx?: object;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ icon, children, action, sx }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: 1,
      gap: 1,
      ...sx,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
      {icon && (
        <Box sx={{ color: '#208040', display: 'flex', alignItems: 'center', fontSize: '1rem' }}>
          {icon}
        </Box>
      )}
      <Typography
        sx={{
          fontFamily: '"Montserrat", sans-serif',
          fontSize: '0.8125rem',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          color: 'text.primary',
        }}
      >
        {children}
      </Typography>
    </Box>
    {action}
  </Box>
);

export default SectionTitle;
